import React, { useState } from 'react';
import styled from 'styled-components/macro';
import PopupDialog from './ui/PopupDialog';
import BackupList from './ui/BackupList';
import SelectGrammarPattern from './ui/SelectGrammarPattern';
import GlobalSearchAndReplace from './ui/GlobalSearchAndReplace';

const PopupsWrapper = styled.div`
    font-family: Roboto, Helvetica, Arial, sans-serif;
`;

export const BackupDialog = ({ context }) => {
    const [backupSelection, setBackupSelection] = useState([]);

    return (
        <PopupDialog
            open={context.showBackupDialog} setOpen={() => context.update({ showBackupDialog: false })}
            title="Select backups" onOK={() => context.restoreBackups(backupSelection)} onCancel={() => {
        }}
        >
            <BackupList setSelection={setBackupSelection}/>
        </PopupDialog>
    );
};

export const AlertDialog = ({ context }) => (
    <PopupDialog open={context.showAlert} setOpen={context.setShowAlert} error title="Notice" onOK={!context.hideOK && (() => {})} >
        {context.alertMessage}
    </PopupDialog>
);

export const DeleteConfirmDialog = ({ context }) => (
    <PopupDialog
        open={context.showDeleteConfirm} setOpen={context.setShowDeleteConfirm}
        title={`Confirm ${context.deletingNodeDescr} delete`} onOK={context.onDeleteConfirmed} onCancel={() => context.setShowDeleteConfirm(false)}
    >
        {`Please confirm deletion of ${context.deletingNodeDescr}.`}
    </PopupDialog>
);

export const ConfirmDialog = ({ context }) => (
    <PopupDialog
        open={context.showConfirm} setOpen={context.setShowConfirm}
        title="Please confirm" onOK={context.confirmCallback} onCancel={() => context.setShowConfirm(false)}
    >
        {context.confirmMessage}
    </PopupDialog>
);

export const AssignPatternDialog = ({ context }) => {
    const [pattern, setPattern] = useState(null);

    return (
        <PopupDialog
            open={context.showAssignPatternDialog} setOpen={() => context.update({ showAssignPatternDialog: false })}
            title="Assign lesson to selected Grammar Library pattern" onOK={() => context.assignToGrammarPattern(pattern)} onCancel={() => {
        }}
        >
            <SelectGrammarPattern setPattern={setPattern}/>
        </PopupDialog>
    );
};

export const GlobalSRDialog = ({ context }) => {
    const [pattern, setPattern] = useState(null);

    return (
        <PopupDialog
            open={context.showGlobalSRDialog} setOpen={() => context.update({ showGlobalSRDialog: false })}
            title="Global search and replace"
        >
            <GlobalSearchAndReplace setPattern={setPattern}/>
        </PopupDialog>
    );
};

const EditorPopups = ({ context} ) => {

    return (
        <PopupsWrapper>
            { context.showDeleteConfirm && <DeleteConfirmDialog context={context} /> }
            { context.showConfirm && <ConfirmDialog context={context} /> }
            { context.showAlert && <AlertDialog context={context} /> }
            { context.showBackupDialog && <BackupDialog context={context} /> }
            { context.showAssignPatternDialog && <AssignPatternDialog context={context} /> }
            { context.showGlobalSRDialog && <GlobalSRDialog context={context} /> }
        </PopupsWrapper>
    );
};

export default EditorPopups;
